"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSearch = exports.getQuery = exports.getOrSetABTestGroup = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _envConstants = require("../env-constants");
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var updateSearch = exports.updateSearch = function updateSearch(location, updates) {
  var query = _queryString["default"].parse(location === null || location === void 0 ? void 0 : location.search);
  var newQuery = _objectSpread(_objectSpread({}, query), updates);
  Object.keys(newQuery).forEach(function (key) {
    return newQuery[key] === null ? delete newQuery[key] : '';
  });
  var search = _queryString["default"].stringify(newQuery);
  return search;
};
var getQuery = exports.getQuery = function getQuery(location) {
  var query = _queryString["default"].parse(location.search);
  return query;
};
var getOrSetABTestGroup = exports.getOrSetABTestGroup = function getOrSetABTestGroup(history) {
  var _history$location;
  var cookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.AB_TEST_COOKIES.FUNNEL_SWITCH;
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 120;
  var query = getQuery(history.location);
  var groupOnQuery = query[cookie];
  var groupOnCookie = _jsCookie["default"].get(cookie);
  var group;
  // when group is not set anywhere, assign random group
  if (groupOnQuery === undefined && groupOnCookie === undefined) {
    group = Math.random() < 0.3;
  } else if (groupOnQuery !== undefined) {
    group = groupOnQuery === 'true' || groupOnQuery === true; // Convert query param to boolean
  } else if (groupOnCookie !== undefined) {
    group = groupOnCookie === 'true' || groupOnCookie === true; // Convert cookie to boolean
  }

  // Set cookie if it's not already set or if the value has changed
  if (groupOnCookie === undefined || (groupOnCookie === 'true' || groupOnCookie === true) !== group) {
    _jsCookie["default"].set(cookie, group, {
      expires: expires
    });
  }

  // Update the search parameters in the URL
  var newSearch = updateSearch(history.location, (0, _defineProperty2["default"])({}, cookie, group));
  if (((_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.search) !== newSearch) {
    if (_envConstants.ENV.IS_NEXT) {
      history.replace({
        pathname: history.pathname,
        query: _objectSpread(_objectSpread(_objectSpread({}, history.query), query), {}, (0, _defineProperty2["default"])({}, cookie, group))
      }, undefined, {
        shallow: true
      });
    } else {
      history.replace({
        pathname: history.location.pathname,
        search: newSearch
      });
    }
  }
  return group;
};